import { createReducer, on } from '@ngrx/store';
import { AuthState } from './auth.state';

import * as actions from './auth.actions';

const initialState: AuthState = {
  loading: false,
  profile: null,
  token: null,
  error: false,
};

export const authReducer = createReducer(
  initialState,
  on(actions.login, (state) => ({
    ...state,
    loading: false,
    error: false,
  })),
  on(actions.loginFail, (state) => ({
    ...state,
    loading: false,
    error: true,
  })),
  on(actions.loginSuccess, (state, { token }) => ({
    ...state,
    loading: false,
    token,
    error: false,
  })),
  on(actions.fetchProfileSuccess, (state, { profile }) => ({
    ...state,
    loading: false,
    profile,
    error: false,
  })),
  on(actions.fetchProfileFail, (state) => ({
    ...state,
    loading: false,
    error: true,
  })),
  on(actions.logout, (state) => ({
    ...state,
    loading: false,
    profile: null,
    token: null,
    error: false,
  })),
);
